const create = (o, t) => ({ type: t.is })

const onCreate = () => {}
export default {
    create,
    onCreate,
}
